import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4b5a505e&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=4b5a505e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a505e",
  null
  
)

export default component.exports